(function () {
  function initMaterialsSliders() {
    if (typeof Flickity === 'undefined') return;

    var wrappers = document.querySelectorAll('.rev-p-Recipe__MaterialsSliderWrapper');
    wrappers.forEach(function (wrapper) {
      var slider = wrapper.querySelector('.js-materials-flickity');
      if (!slider || slider.classList.contains('flickity-enabled')) return;

      var prevButton = wrapper.querySelector('.js-materials-prev');
      var nextButton = wrapper.querySelector('.js-materials-next');
      var controlsEl = wrapper.querySelector('.rev-p-Recipe__MaterialsControls');

      var flkty = new Flickity(slider, {
        cellAlign: 'left',
        contain: false,
        wrapAround: false,
        prevNextButtons: false,
        pageDots: true,
        freeScroll: false,
        selectedAttraction: 0.2,
        friction: 0.8
      });

      var dots = slider.querySelector('.flickity-page-dots');
      if (dots && controlsEl) controlsEl.prepend(dots);

      function updatePager() {
        if (prevButton) prevButton.classList.toggle('is-disabled', flkty.selectedIndex === 0);
        if (nextButton) nextButton.classList.toggle('is-disabled', flkty.selectedIndex === flkty.slides.length - 1);
      }

      if (prevButton) prevButton.addEventListener('click', function () {
        flkty.previous();
        setTimeout(updatePager, 0);
      });
      if (nextButton) nextButton.addEventListener('click', function () {
        flkty.next();
        setTimeout(updatePager, 0);
      });

      flkty.on('settle', updatePager);
      updatePager();
    });
  }

  document.addEventListener('DOMContentLoaded', initMaterialsSliders);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initMaterialsSliders, 500);
  });
})();
